// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"30fd562f","130":"81cd69e2","174":"4eb8e06c","369":"35cae6c1","435":"ce51225b","484":"f1806a85","636":"9a2afc10","652":"a0bf284e","721":"8176365d","775":"2aaa4b10","822":"5f99455b","858":"050e592c","932":"cc1a6973","966":"921d32b0"}[chunkId] + ".chunk.js";
};